export default __webpack_public_path__ + "static/media/qr-blank-standard.3410aab0.png";